import {Link} from "react-router-dom";

const NotFoundPage = () => {
    return (
        <div>
            <h1>صفحه مورد نظر یافت نشد</h1>
            <p>متاسفانه صفحه ای که به دنبال آن هستید یافت نشد</p>
            <Link to="/">بازگشت به صفحه اصلی</Link>
        </div>
    )
}
export default NotFoundPage;